import { render, staticRenderFns } from "./PageFixedPriceProducts.vue?vue&type=template&id=fd07cfd8&scoped=true&"
import script from "./PageFixedPriceProducts.vue?vue&type=script&lang=js&"
export * from "./PageFixedPriceProducts.vue?vue&type=script&lang=js&"
import style0 from "./PageFixedPriceProducts.vue?vue&type=style&index=0&id=fd07cfd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd07cfd8",
  null
  
)

export default component.exports